import { Injectable } from '@angular/core';
import { Location, LocationsResponse } from '../../models/api/location';
import { ApiHttpProvider } from '../api-http/api-http';
import { mapLocationsResponse } from './location-mapper';

@Injectable()
export class LocationsProvider {
  private available: Location[] = [];
  private selected: Location = null;

  constructor(private api: ApiHttpProvider) {}

  load(apiKey: string): Promise<Location[]> {
    const provider = this;
    return this.api.postForm<LocationsResponse>('catalogo/locaciones', { apikey: apiKey })
      .then(mapLocationsResponse)
      .then(function (locations) {
        provider.available = locations;
        provider.selected = null;
        return locations.slice();
      });
  }

  getAvailable(): Location[] {
    return this.available.slice();
  }

  select(location: Location): void {
    this.selected = location;
  }

  getSelected(): Location {
    return this.selected;
  }

  clear(): void {
    this.available = [];
    this.selected = null;
  }
}



// WEBPACK FOOTER //
// ./src/providers/locations/locations.ts